// Piktogramy menu — výběr z knihovny `IKONY` prototypu (Lucide‑like, 24×24, stroke 1.8; docs/04
// „Ikony“). Ke každé sekci první doporučený piktogram z `MENU_IKONY_DOPORUCENE` prototypu; sekce bez
// doporučení (Vážení, ISŘ) dostala piktogram z téže knihovny a sekce bez záznamu v `IKONA_SEKCE` ukáže
// písmeno. Výběr ikony v Nastavení přijde s F2.

/** id → [český název, SVG path]. */
export const IKONY: Readonly<Record<string, readonly [string, string]>> = {
  home: ['Domů', 'M3 11.5L12 4l9 7.5M5.5 10.5V20h13v-9.5'],
  clipboard: ['Podložka se seznamem', 'M8 3h8v4H8zM5 5h14v16H5zM9 12h6M9 16h4'],
  sun: [
    'Slunce',
    'M12 7a5 5 0 110 10 5 5 0 010-10zM12 2v2M12 20v2M2 12h2M20 12h2M5 5l1.5 1.5M17.5 17.5L19 19M5 19l1.5-1.5M17.5 6.5L19 5',
  ],
  users: [
    'Osoby',
    'M9 11a3.5 3.5 0 110-7 3.5 3.5 0 010 7zM2.5 20a6.5 6.5 0 0113 0M16 4.5a3.5 3.5 0 010 6.7M21.5 20a6.5 6.5 0 00-4.5-6.1',
  ],
  calendar: ['Kalendář', 'M4 6h16v14H4zM4 10.5h16M8.5 3v5M15.5 3v5'],
  box: ['Krabice', 'M3 8l9-5 9 5v12H3zM3 8.5l9 5 9-5M12 13.5V20'],
  id_card: [
    'Průkaz',
    'M3 5h18v14H3zM9 12a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM5 17a4 4 0 018 0M14 9h5M14 13h5',
  ],
  calculator: [
    'Kalkulačka',
    'M6 2.5h12v19H6zM9 6.5h6M9 11h.01M12 11h.01M15 11h.01M9 14.5h.01M12 14.5h.01M15 14.5h.01M9 18h.01M12 18h.01M15 18h.01',
  ],
  alarm: ['Budík', 'M12 8a6.5 6.5 0 110 13 6.5 6.5 0 010-13zM12 11v3.5l2.3 1.4M9 2.5h6M12 2.5V5'],
  shield_check: [
    'Štít s fajfkou',
    'M12 2.5l8 3v6.5c0 4.5-3.4 7.6-8 9.5-4.6-1.9-8-5-8-9.5V5.5zM8.5 12l2.4 2.4 4.6-4.8',
  ],
  chat: ['Bublina', 'M4 4.5h16V16h-7.5L8 20v-4H4z'],
  inbox: ['Příchozí', 'M3 13l2.5-8h13L21 13v6H3zM3 13h5l1 2.5h6l1-2.5h5'],
  chats: ['Bubliny', 'M4 4.5h16v11h-6.5L9 20v-4.5H4zM8 8.5h8M8 11.5h5'],
  tag: ['Cenovka', 'M3 11.5L11.5 3H21v9.5L12.5 21zM16.4 7.6l.01.01'],
  funnel: ['Trychtýř', 'M3.5 4h17l-6.5 7.5V19l-4-2v-5.5z'],
  building: ['Budova', 'M4 21h16M5.5 21V4h9v17M14.5 9H19v12M8.5 8h3M8.5 12h3M8.5 16h3'],
  banknote: [
    'Bankovka',
    'M3 7h18v11H3zM12 14.8a2.3 2.3 0 100-4.6 2.3 2.3 0 000 4.6M3 11h2M19 14h2',
  ],
  swap: ['Výměna', 'M7 3v12M7 15l-3-3M7 15l3-3M17 21V9M17 9l-3 3M17 9l3 3'],
  user_card: [
    'Osoba na kartě',
    'M4 4h16v16H4zM12 11a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM7 18a5 5 0 0110 0',
  ],
  team: [
    'Tým',
    'M9 11a3.2 3.2 0 100-6.4A3.2 3.2 0 009 11zM3.5 19a5.5 5.5 0 0111 0M16 10.5a2.6 2.6 0 100-5.2 2.6 2.6 0 000 5.2zM15 14.2c2.9 0 5.3 1.8 5.5 4.8',
  ],
  truck: [
    'Nákladní auto',
    'M2.5 7h11v9h-11zM13.5 10h4.5l3.5 3.5V16h-2.5M6 19a1.8 1.8 0 100-3.6A1.8 1.8 0 006 19zM17 19a1.8 1.8 0 100-3.6A1.8 1.8 0 0017 19z',
  ],
  dollar: [
    'Znak měny',
    'M12 3v18M16.5 6.5c-1-1.2-2.7-1.8-4.5-1.6-2 .2-3.5 1.4-3.5 3 0 4 8 2.2 8 6.2 0 1.6-1.7 2.9-4 2.9-1.9 0-3.6-.8-4.5-2',
  ],
  shelf: ['Regál', 'M4 7h16v13H4zM4 11h16M9 7V4h6v3M9 15h6'],
  file_text: ['Dokument s textem', 'M6.5 2.5h8l4 4V21.5h-12zM14 2.5V7h4.5M9.5 12.5h5M9.5 16.5h5'],
  file_check: ['Dokument s fajfkou', 'M6.5 2.5h8l4 4V21.5h-12zM14 2.5V7h4.5M9 15.5l2 2 4-4.5'],
  chart_bar: ['Sloupcový graf', 'M4.5 20v-8M10.5 20V4.5M16.5 20v-5.5M21 20H3'],
  grid: ['Mřížka', 'M4 4h16v16H4zM4 12h16M12 4v16'],
  template: ['Šablona', 'M7 3h10v18H7zM10 7.5h4M10 11h4M10 14.5h3'],
  archive: ['Archiv', 'M3 5h18v4H3zM5 9v11h14V9M10 13h4'],
  scale: [
    'Váha',
    'M12 3v18M8 21h8M5 6.5h14M6.5 6.5L4 12a3.5 3.5 0 006 0zM17.5 6.5L15 12a3.5 3.5 0 006 0z',
  ],
  weight: ['Závaží', 'M8 8h8l3 12H5zM12 8a2.5 2.5 0 100-5 2.5 2.5 0 000 5z'],
  shield: ['Štít', 'M12 2.5l8 3v6.5c0 4.5-3.4 7.6-8 9.5-4.6-1.9-8-5-8-9.5V5.5z'],
  flag: ['Vlajka', 'M5 21V4h13.5l-2.5 4 2.5 4H5'],
  sliders: ['Posuvníky', 'M4 7h16M4 12h16M4 17h16M9 5v4M15 10v4M7 15v4'],
  book: ['Kniha', 'M4 4h6a2 2 0 012 2v14a2 2 0 00-2-2H4zM20 4h-6a2 2 0 00-2 2v14a2 2 0 012-2h6z'],
  knihovna: [
    'Knihovna předpisů',
    'M4 4h4v16H4zM10 4h4v16h-4zM15.5 5.2l3.9-1 3.1 14.6-3.9 1zM4 8h4M10 8h4',
  ],
  star: ['Hvězda', 'M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9z'],
  search: ['Lupa', 'M11 4a7 7 0 100 14 7 7 0 000-14zM20 20l-4-4'],
  menu: ['Tři čárky', 'M4 6h16M4 12h16M4 18h16'],
  chevron_left: ['Šipka vlevo', 'M15 5l-7 7 7 7'],
  chevron_right: ['Šipka vpravo', 'M9 5l7 7-7 7'],
  chevron_down: ['Šipka dolů', 'M5 9l7 7 7-7'],
  moon: ['Měsíc', 'M20 14.5A8 8 0 019.5 4a8 8 0 1010.5 10.5z'],
  eye: ['Oko', 'M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12zM12 15a3 3 0 100-6 3 3 0 000 6z'],
  x: ['Zavřít', 'M6 6l12 12M18 6L6 18'],
  // Zvonek notifikací v hlavičce (krok 4.3) a tužka „poznámka k dni“ v kalendáři.
  bell: ['Zvonek', 'M6 16.5V11a6 6 0 0112 0v5.5l1.5 2h-15zM10 20.5a2 2 0 004 0'],
  pencil: ['Tužka', 'M4 20l4.5-1 10-10-3.5-3.5-10 10zM13.5 7l3.5 3.5'],
  // Mapa provozu (krok 11.11, GPS etapa 2): složená mapa se špendlíkem.
  map: ['Mapa', 'M3 6l6-2 6 2 6-2v14l-6 2-6-2-6 2zM9 4v14M15 6v14'],
  // Pokladny (krok 6.21): „Peněženka“ z knihovny IKONY prototypu.
  wallet: [
    'Peněženka',
    'M3 7a2 2 0 012-2h13v3M3 7v11a2 2 0 002 2h16V8H5a2 2 0 01-2-1zM16 13.5h.01',
  ],
  // Export do účetnictví (krok 12.4): „Stáhnout“ z knihovny IKONY prototypu.
  download: ['Stáhnout', 'M12 3v10M12 13l-4-4M12 13l4-4M4 17h16v4H4z'],
  // Náhrada glyfů ✓ ✎ ★ ▲▼ 📷 ⚑ ⛔ (rozhodnutí zadavatele 23. 10. 2026, 05/3884 a; docs/04 „žádné Unicode glyfy“).
  check: ['Fajfka', 'M5 12.5l4.5 4.5L19 7'],
  camera: [
    'Fotoaparát',
    'M4 8h3.5l1.5-2.5h6L16.5 8H20v11H4zM12 16a3.25 3.25 0 100-6.5 3.25 3.25 0 000 6.5z',
  ],
  chevron_up: ['Šipka nahoru', 'M5 15l7-7 7 7'],
  alert: ['Výstraha', 'M12 3.5L2.5 20h19zM12 9.5v4.5M12 17.2v.01'],
  ban: ['Zákaz', 'M12 3a9 9 0 100 18 9 9 0 000-18zM5.6 5.6l12.8 12.8'],
  stop: ['Stop', 'M6 6h12v12H6z'],
};

/** Výchozí piktogram sekce (první doporučený v prototypu); bez záznamu → písmeno. */
export const IKONA_SEKCE: Readonly<Record<string, string>> = {
  home: 'home',
  zakazky: 'clipboard',
  // Audity u zákazníků (24. 10. 2026, W80): dokument s fajfkou — protokol auditu.
  audity: 'file_check',
  muj_den: 'sun',
  mapa_provozu: 'map',
  // Auta na cestě (W95): nákladní auto.
  auta_na_ceste: 'truck',
  zakaznici: 'users',
  odberatele: 'dollar',
  kalendar: 'calendar',
  sklad_evidence: 'box',
  'sklad_evidence:evidence': 'clipboard',
  'sklad_evidence:ilno': 'id_card',
  ucetnictvi: 'calculator',
  dochazka: 'alarm',
  ke_kontrole: 'shield_check',
  k_vyrizeni: 'inbox',
  poptavky: 'chat',
  nabidky: 'tag',
  pipeline: 'funnel',
  moje_firmy: 'building',
  pohledavky: 'banknote',
  export_ucetni: 'download',
  pokladny: 'wallet',
  svoz_pozadavky: 'swap',
  kontakty: 'user_card',
  zamestnanci: 'team',
  'zamestnanci:zajemci': 'id_card',
  vozidla: 'truck',
  ceniky: 'dollar',
  sklad: 'shelf',
  smlouvy: 'file_text',
  ecosmlouvy: 'file_check',
  statistiky: 'chart_bar',
  interni_cenik: 'grid',
  vzory_dokumentu: 'template',
  archiv_dokumentu: 'archive',
  celni_sprava: 'scale',
  // Vážení a ISŘ / Moje školení a hlášení prototyp v `MENU_IKONY_DOPORUCENE` nemá; bez ikony měly v levém menu
  // prázdnou dlaždici (nálezy SKL-S2, DIS-S6) — závaží a štít z knihovny `IKONY` prototypu.
  vazeni: 'weight',
  iso: 'shield',
  hlaseni: 'flag',
  interakce: 'chats',
  nastaveni: 'sliders',
  asistent: 'search',
  pravidla_ai: 'book',
  znalostni_baze: 'knihovna',
};

interface IkonaProps {
  id: string;
  /** Velikost v px (prototyp 15 v liště, 16/20 v tlačítkách). */
  velikost?: number;
  /** Vyplněná (hvězdička v oblíbených). */
  vyplnena?: boolean;
  className?: string;
}

/** SVG piktogram z knihovny; neznámé id nevykreslí nic. Dekorativní — popisek nese text vedle. */
export function Ikona({ id, velikost = 15, vyplnena = false, className }: IkonaProps) {
  const zaznam = IKONY[id];
  if (!zaznam) return null;
  return (
    <svg
      width={velikost}
      height={velikost}
      viewBox="0 0 24 24"
      fill={vyplnena ? 'currentColor' : 'none'}
      aria-hidden="true"
      focusable="false"
      className={className ? `ikona ${className}` : 'ikona'}
    >
      <path
        d={zaznam[1]}
        stroke="currentColor"
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Ikona sekce podle klíče, nebo `null` (lišta pak ukáže první písmeno názvu jako prototyp). */
export function IkonaSekce({ klic, velikost }: { klic: string; velikost?: number }) {
  const id = IKONA_SEKCE[klic];
  return id ? <Ikona id={id} velikost={velikost} /> : null;
}
